// tabs/OnHandInventoryTab.jsx - On-hand inventory tab
import React, { useState, useMemo } from 'react';
import { Box } from '@mantine/core';
import { MantineReactTable, useMantineReactTable } from 'mantine-react-table';

const OnHandInventoryTab = ({ selectedLineId }) => {
  // Sample inventory data
  const [inventoryData, setInventoryData] = useState([
    {
      whNo: '01',
      location: 'A1-B2-C3',
      qty: 15,
      um: 'EA',
      cond: 'NE',
      reserved: 0,
      booked: 0,
      inHouseQA: 0,
      transport: 0,
      received: '11/30/2023 14:1',
      company: 'ABC',
      division: 'DEF',
      timeControl: '',
      goodTill: '',
      netCost: 150.00
    }
  ]);

  const columns = useMemo(() => [
    {
      accessorKey: 'whNo',
      header: 'W/H No.',
      size: 70
    },
    {
      accessorKey: 'location',
      header: 'Location',
      size: 100
    },
    {
      accessorKey: 'qty',
      header: 'Qty',
      size: 60,
      Cell: ({ cell }) => cell.getValue()?.toLocaleString()
    },
    {
      accessorKey: 'um',
      header: 'UM',
      size: 50
    },
    {
      accessorKey: 'cond',
      header: 'Cond',
      size: 60
    },
    {
      accessorKey: 'reserved',
      header: 'Reserved',
      size: 80,
      Cell: ({ cell }) => cell.getValue()?.toLocaleString()
    },
    {
      accessorKey: 'booked',
      header: 'Booked',
      size: 70,
      Cell: ({ cell }) => cell.getValue()?.toLocaleString()
    },
    {
      accessorKey: 'inHouseQA',
      header: 'In house/QA',
      size: 100,
      Cell: ({ cell }) => cell.getValue()?.toLocaleString()
    },
    {
      accessorKey: 'transport',
      header: 'Transport',
      size: 80,
      Cell: ({ cell }) => cell.getValue()?.toLocaleString()
    },
    {
      accessorKey: 'received',
      header: 'Received',
      size: 120
    },
    {
      accessorKey: 'company',
      header: 'Company',
      size: 80
    },
    {
      accessorKey: 'division',
      header: 'Division',
      size: 80
    },
    {
      accessorKey: 'timeControl',
      header: 'Time Control',
      size: 100
    },
    {
      accessorKey: 'goodTill',
      header: 'Good Till',
      size: 90
    },
    {
      accessorKey: 'netCost',
      header: 'Net Cost',
      size: 90,
      Cell: ({ cell }) => cell.getValue()?.toFixed(2)
    }
  ], []);

  const table = useMantineReactTable({
    columns,
    data: inventoryData,
    enableRowSelection: false,
    enableColumnOrdering: false,
    enableGlobalFilter: false,
    enablePagination: false,
    enableBottomToolbar: false,
    enableTopToolbar: false,
    mantineTableProps: {
      style: { fontSize: '12px' }
    },
    mantineTableBodyRowProps: ({ row }) => ({
      style: {
        backgroundColor: row.index === 0 ? '#e8f5e8' : 'transparent'
      }
    })
  });

  return (
    <Box p="md">
      <Box style={{ height: '300px', overflow: 'auto' }}>
        <MantineReactTable table={table} />
      </Box>
    </Box>
  );
};

export default OnHandInventoryTab;